import "./Solution.css";
import dash from "../../Images/dashbaordimg.png";
import instant from "../../Images/compare.png";
import candidate from "../../Images/candidate.png";
import CV from "../../Images/cv.png";
import car from "../../Images/carrer.png";
import job from "../../Images/job.png";
import FoodrnaContactUs from "../../Pages/Foodarna/FoodrnaContactUs/FoodrnaContactUs";
import CustomTabs from "../CustomTabButton";

const Solution = () => {
  const DashboardContent = () => (
    <div>
      <img src={dash} alt="Image" />{" "}
    </div>
  );
  const InstantMatchingContent = () => (
    <div>
      <img src={instant} alt="Image" />{" "}
    </div>
  );
  const JobsContent = () => (
    <div>
      <img src={job} alt="Image" />{" "}
    </div>
  );
  const CandidatesContent = () => (
    <div>
      <img src={candidate} alt="Image" />{" "}
    </div>
  );
  const GenerateCVContent = () => (
    <div>
      <img src={CV} alt="Image" />{" "}
    </div>
  );
  const CareerPageContent = () => (
    <div>
      <img src={car} alt="Image" />{" "}
    </div>
  );

  const tabs = [
    {
      id: "dashboard",
      label: "Dashboard",
      content: <DashboardContent />,
    },
    {
      id: "instantMatching",
      label: "Instant Matching",
      content: <InstantMatchingContent />,
    },
    {
      id: "jobs",
      label: "Jobs",
      content: <JobsContent />,
    },
    {
      id: "candidates",
      label: "Candidates",
      content: <CandidatesContent />,
    },
    {
      id: "generate",
      label: "Generate CV",
      content: <GenerateCVContent />,
    },
    {
      id: "careerPage",
      label: "Career Page",
      content: <CareerPageContent />,
    },
  ];

  return (
    <div className="foodrna-featurework" style={{ background: "#253678" }}>
      <div className="the-art-flavour">
        <CustomTabs tabs={tabs} defaultActiveTab="dashboard" />
      </div>
      <FoodrnaContactUs />
    </div>
  );
};

export default Solution;
